import defaultArrayFrom, {
  arrayFrom as arrayFromInternal,
  castArray as castArrayInternal,
  ensureArray as ensureArrayInternal,
  optionalArrayFrom as optionalArrayFromInternal,
} from '@sweetistics/contracts/utils/arrayish';

export type { MaybeReadonlyArray } from '@sweetistics/contracts/utils/arrayish';

export const arrayFrom: typeof arrayFromInternal = (...arguments_) => arrayFromInternal(...arguments_);
export const ensureArray: typeof ensureArrayInternal = (...arguments_) => ensureArrayInternal(...arguments_);
export const optionalArrayFrom: typeof optionalArrayFromInternal = (...arguments_) =>
  optionalArrayFromInternal(...arguments_);

export const castArray: typeof castArrayInternal = (...arguments_) => castArrayInternal(...arguments_);

const toArrayWrapper: typeof defaultArrayFrom = (...arguments_) => defaultArrayFrom(...arguments_);
export const toArray = toArrayWrapper;
export default toArrayWrapper;
